import { Loadable } from 'utils/components'
import { CMS_PATH as path } from 'constants/paths'

export default {
  path,
  component: Loadable({
    loader: () => import(/* webpackChunkName: 'CMS' */ './components/CMSPage'),
  }),
}
